exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-logo {\r\n    width: 140px;\r\n    position: relative;\r\n    bottom: 11px;\r\n}\r\n\r\na {\r\n    cursor: pointer;\r\n}\r\n\r\n.checkin-modal {\r\n    text-align: center;\r\n}\r\n\r\n.checkin-modal i.fa-spinner {\r\n    font-size: 100px;\r\n}\r\n\r\n.navbar-default {\r\n    border-color: #d0d0d0;\r\n}\r\n\r\n.btn.btn-info {\r\n    background: linear-gradient(to bottom, #86d1fd 0%,#3696da 100%);\r\n}\r\n\r\nbutton.btn.btn-blank {\r\n    background: white !important;\r\n    border: 1px #3e81bb solid !important;\r\n}\r\n\r\n.spacer {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.spinner-small {\r\n    font-size: inherit !important;\r\n}\r\n\r\n.renewal-checkbox {\r\n    position:relative;\r\n    top:2px;\r\n    left:5px;\r\n    cursor: pointer;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// c:/Projects/CCLibrary/Client/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = 1